import { Diamond } from "@src/types/DiamondDetail";
import QuantitySelector from "../QuantitySelector";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import styled from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import currency from "currency.js";
import { hasZeroDecimals } from "@scenes/pdp/utils/utils";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useUserCurrency } from "../../../hooks/getCurrency";

type QuantitySelectionProps = {
  itemDetail: Diamond;
  selectedQuantity: number;
  setSelectedQuantity: (quantity: number) => void;
};

const QuantitySelection = ({
  itemDetail,
  selectedQuantity,
  setSelectedQuantity,
}: QuantitySelectionProps) => {
  const { t, theme, typography } = useScreenOptionsHooks();
  const { roundUpPrices } = useUserInfo();
  const userCurrency = useUserCurrency();
  return (
    <>
      <QuantitySelectionContainer>
        <QuantitySelector
          label={t("productDetail.bottomSection.quantity.text", "Quantity")}
          min={1}
          max={99}
          defaultValue={selectedQuantity}
          onChange={setSelectedQuantity}
        />
        <TotalPriceContainer>
          <VDBText color={theme["core-06"]} type={typography["Minor-R"]}>
            {t("productDetail.bottomSection.totalPrice.text")}
          </VDBText>
          <Spacer size={SpaceType.Basic} />
          <VDBText color={theme["core-05"]} type={typography["H1-B"]}>
            {itemDetail?.total_sales_price
              ? currency(selectedQuantity * itemDetail?.total_sales_price, {
                  symbol: userCurrency,
                  precision:
                    roundUpPrices() ||
                    hasZeroDecimals(
                      selectedQuantity * itemDetail?.total_sales_price
                    )
                      ? 0
                      : 2,
                }).format()
              : "-"}
          </VDBText>
        </TotalPriceContainer>
      </QuantitySelectionContainer>
      <Spacer size={SpaceType.Big} />
    </>
  );
};

const QuantitySelectionContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-horizontal: ${SpaceType.Double}px;
`;

const TotalPriceContainer = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${SpaceType.Double}px;
  justify-content: center;
`;

export default QuantitySelection;
